export const QuestionType = {
  MultipleChoice: "multiple_choice",
};
